import PropTypes from 'prop-types';

export const SeqCell = ({ row: { index } }) => index + 1;

SeqCell.propTypes = {
  row: PropTypes.shape({
    index: PropTypes.number.isRequired,
  }).isRequired,
};
